export default __webpack_public_path__ + "static/media/user-group-solid-circle.e5a17d35.svg";